import { Component, OnInit, Input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';

@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss'],
})
export class CreateGroupComponent implements OnInit {
  @Input() inputForm: FormGroup;

  constructor() {}

  get groupName(): AbstractControl {
    return this.inputForm.get('group_name');
  }

  ngOnInit() {
    this.inputForm.addControl(
      'group_name',
      new FormControl('', [Validators.required])
    );
  }
}
